import { createApiCall } from 'lib/base';

const FETCH_MARKET_INDEX_DETAIL_API_ID =
  'DASHBOARD/FETCH_MARKET_INDEX_DETAIL_API';

const apiCall = createApiCall(
  FETCH_MARKET_INDEX_DETAIL_API_ID,
  ({ id }) => ({
    endpoint: `/api/admin/market-indexes/${id}`,
    method: 'GET',
  })
);

export default apiCall;
